import React, { Component } from 'react';
import { TweenLite, TimelineLite } from "gsap";

class Success extends Component {

	constructor(props) {
		super(props);
		this.defaultMessage = 'Thanks for your enquiry, we will be in touch real soon.';
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.animate !== this.props.animate && nextProps.animate === true) {
			this.animate();
		}
	}

	animate() {
		let tl = new TimelineLite();
		tl.set(this.success, {opacity: 0, display: 'block'});
		tl.to(this.success, 0.5, {opacity: 1});
		tl.to(this.image, 0.2, {opacity: 1}, 0);
		tl.fromTo(this.image, 0.4, {scale: 0.5}, {scale: 1.5}, 0);
		tl.to(this.image, 0.2, {scale: 1});
	}

	render() {
		return (
			<div className="success-msg" ref={el => this.success = el}>
				<div className="inner">
					<img
						src="/images/icon-circle-tick.svg"
						alt="Success!"
						ref={el => this.image = el}
						style={{opacity: 0}}
					/>
					{(this.props.children ? this.props.children : <p>{this.defaultMessage}</p>)}
				</div>
			</div>
		);
	}

}

export default Success;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Success.js